export default function SubtractIcon({
  size = 27,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={23}
        viewBox='0 0 28 23'
        fill='none'
      >
        <path
          d='M15.0323 0C15.1717 0 15.3065 0.0200492 15.4346 0.0556641C15.4472 0.0591808 15.4602 0.0615861 15.4727 0.0654297C15.4926 0.0715429 15.5117 0.080002 15.5313 0.0869141C15.5571 0.0960434 15.5831 0.104706 15.6084 0.115234C15.7872 0.189707 15.9481 0.297853 16.084 0.431641C16.0868 0.434386 16.09 0.436684 16.0928 0.439453L26.5928 10.9395C26.8314 11.1781 26.9896 11.4966 27.0244 11.8516C27.0293 11.9007 27.0323 11.9502 27.0323 12V23H24.0323V13.5H15.0323C14.2038 13.5 13.5323 12.8284 13.5323 12V3H4.53226C4.13443 3 3.75301 3.15815 3.47171 3.43945C3.19041 3.72076 3.03226 4.10217 3.03226 4.5V23H0.0322571V4.5C0.0322571 3.30653 0.506703 2.16227 1.35062 1.31836C2.19453 0.474445 3.33878 0 4.53226 0H15.0323ZM16.5323 10.5H21.9112L16.5323 5.12109V10.5Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}
